function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 10.092)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.829 21.09c6.902 2.428 8.459 2.975 3.13 5.117-.023-.041.01.285 0 2.944-.007 1.686-5.497 1.686-5.501 0v-2.944H20.06l.024 2.944c-.086 1.684-5.574 1.688-5.555 0v-2.944c-4.687-.364-7.551-1.865-9.044-5.64-.087.009-1.023.006-2.932 0-1.566.204-2.363-.99-2.388-3.584-.026-2.594.604-4.022 1.892-4.287h2.577c1.306-4.12 3.28-6.695 7.795-7.868.013-.942-.02-4.29 0-4.789 3.666-.087 5.084 1.784 5.084 4.789.077.045.228.058.218.132-.333 2.61-4.545 1.1-4.328 5.994.08 1.775 1.474 3.646 4.042 5.471 2.569 1.825 3.482 2.238 10.384 4.666zm-17.761-6.583c.942 0 1.706-.777 1.706-1.736 0-.96-.764-1.737-1.706-1.737-.943 0-1.707.778-1.707 1.737 0 .959.764 1.736 1.707 1.736z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.195 15.423c-.009.627-.036 1.24-.093 1.838-.348 3.694-1.814 6.804-7.143 8.946-.023-.041.01.285 0 2.944-.007 1.686-5.497 1.686-5.501 0v-2.944H20.06l.024 2.944c-.086 1.684-5.574 1.688-5.555 0v-2.944c-4.687-.364-7.551-1.865-9.044-5.64-.087.009-1.023.006-2.932 0-1.566.204-2.363-.99-2.388-3.584-.026-2.594.604-4.022 1.892-4.287h2.577c1.306-4.12 3.28-6.695 7.795-7.868.013-.942-.02-4.29 0-4.789 3.666-.087 5.084 1.784 5.084 4.789 8.127.014 3.432-.036 9.66 0 3.277.018 6.018 1.148 7.952 3.162",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 10.091,
  cy: 12.795,
  rx: 1.73,
  ry: 1.761
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  x: 18.205,
  y: 6.937,
  width: 9.382,
  height: 2.522,
  rx: 1.019
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.104 25.847c-.504.43-.86.971-1.032 1.59-.581 2.553-1.82 3.58-4.458 3.413 3.82 4.197 8.89 3.915 11.414-.078.35-.552-.469-2.491-2.054-2.33-5.788.593-3.444-2.959-3.87-2.595z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.156 24.96l1.668 1.855 14.35-10.47.074-.056a2.237 2.237 0 00.265-3.251 2.174 2.174 0 00-3.071-.148L32.156 24.96zm-7.202 8.276c3.306.053 5.397-.965 6.273-3.055m6.774-10.248c1.466 1.379 1.562 2.568 1.6 2.861",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.892 30.696c.555.867 3.798 4.544 8.067 2.64 2.846-1.27 4.104-3.323 3.773-6.161l-1.784-2.137c-2.708-.458-4.396-.015-5.065 1.33-2.483 4.994-2.385 4.18-4.99 4.328z",
  stroke: "#371447"
}));

function SvgMakeYourOwnMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMakeYourOwnMd;